import DOMPurify from 'dompurify'

/**
 * Render an agent message as safe HTML: escape, then link phone numbers as tel: anchors.
 * URLs stay plain text — model-derived links are deliberately not tappable.
 *
 * @param {string} text raw model output
 *
 * @returns {string} sanitized HTML
 */
export function renderAgentMessage(text) {
  if (!text) return ''

  const escaped = String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')

  // split shields url text from the phone regex
  const withPhones = escaped
    .split(/(https?:\/\/[^\s]+)/g)
    .map((segment) =>
      /^https?:\/\//.test(segment)
        ? segment
        : segment.replace(
          /((?:\+?1[-.\s]?)?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4})/g,
          (match) => `<a href="tel:${match.replace(/[^\d+]/g, '')}">${match}</a>`
        )
    )
    .join('')

  return DOMPurify.sanitize(withPhones, {
    ALLOWED_TAGS: ['a'],
    ALLOWED_ATTR: ['href'],
  })
}
